import Ajax from 'js/utils/ajax/ajax.js';

export const getConcerns = () => Ajax.get('/shops/v1/concerns');
